function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.64998 11.0001C1.64998 5.83623 5.83611 1.6501 11 1.6501C16.1638 1.6501 20.35 5.83623 20.35 11.0001C20.35 16.164 16.1638 20.3501 11 20.3501C5.83611 20.3501 1.64998 16.164 1.64998 11.0001ZM11 0.350098C5.11814 0.350098 0.349976 5.11826 0.349976 11.0001C0.349976 16.8819 5.11814 21.6501 11 21.6501C16.8818 21.6501 21.65 16.8819 21.65 11.0001C21.65 5.11826 16.8818 0.350098 11 0.350098ZM6.99998 10.3501C6.64099 10.3501 6.34998 10.6411 6.34998 11.0001C6.34998 11.3591 6.64099 11.6501 6.99998 11.6501H15C15.359 11.6501 15.65 11.3591 15.65 11.0001C15.65 10.6411 15.359 10.3501 15 10.3501H6.99998Z",
  fill: "#2F7067"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.69e23cd0.svg";
export { ForwardRef as ReactComponent };